import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPromisedData,
  fetchAllPostPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { getUpdatedTime } from "views/pages/manage/employeeManagement/userProfile/helper";
import { getFormattedDate } from "views/pages/manage/employeeManagement/userProfile/helper";
import { getDownloadFileUrl } from "../../constant/common";

export const INITIAL_FILTER_STATE = {
  term: "",
  batch: [],
  categoryDispValue: "",
  materialId: [],
  isMissingConsent: false,
};

export const SEARCH_BY = [
  {
    key: "psid",
    value: "By PSID",
  },
  {
    key: "applicationId",
    value: "By Application ID",
  },
  {
    key: "rfid",
    value: "By RFID",
  },
];

export const packageCode = [
  "A1",
  "A2",
  "A3",
  "A4",
  "A5",
  "A6",
  "M1",
  "M2",
  "M3",
  "M4",
  "M5",
  "M6",
  "M7",
  "M8",
  "O1",
  "O2",
  "O3",
  "O4",
  "O5",
  "O6",
];

export const packageCodeDropdown = packageCode.map((code) => ({
  label: code,
  value: code,
}));

export const getBatchList = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.batchList.fetchAllBatches}=-1`,
    payload,
    "post"
  );
  if (response?.code === 200)
    return response.data.batchSearchResponseDTOList.map(
      ({ id, batchName }) => ({ label: batchName, value: id })
    );

  return [];
};

export const getMaterialByPackageCode = async ({ packageCode }) => {
  const response = await fetchAllPromisedData(
    `${endpoint.materialMaster.getMaterialByPackageCode}?packageCode=${packageCode}&plantId=HO01`
  );

  if (!response?.length) return [];
  return response.map((obj) => ({
    label: `${obj.materialId} | ${obj.materialDescription}`,
    value: obj.materialId,
  }));
};

export const searchStudentMaterial = async ({ payload, offset, limit }) => {
  const modifiedPayload = updatePayload(payload);

  const response = await fetchAllPostPromisedData(
    `${endpoint.materialDistribution.searchStudentConsentStatus}?offset=${offset}&limit=${limit}`,
    modifiedPayload,
    "post"
  );

  return response;
};

export const getPsidFromRfid = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.getPsidRfidDetail}`,
    payload,
    "post",
    true,
    {},
    "",
    true
  );

  if (response?.code === 404) failureToast(INVALID_RFID_MSG);

  if (response?.code === 200) return response.data;
};

export const saveRfidPsid = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.materialDistribution.saveConsentStatus}`,
    payload,
    "post"
  );

  return response;
};

export const downloadConsentCsv = async (payload) => {
  const modifiedPayload = updatePayload(payload);

  const response = await fetchAllPostPromisedData(
    `${endpoint.materialDistribution.searchStudentConsentStatusDownload}`,
    modifiedPayload,
    "post"
  );
  if (response) {
    getDownloadFileUrl(response.data);
  }
};

export const consentReversal = async (rows) => {
  const modifiedPayload = rows?.map((item) => item.consentId);

  const response = await fetchAllPostPromisedData(
    `${endpoint.materialDistribution.consentReversal}`,
    modifiedPayload,
    "delete",
    false
  );
  return response;
};

const updatePayload = (payload) => {
  const { term, batch, materialId, isMissingConsent, searchBy, searchByValue } =
    payload;
  return {
    termId: [term.id],
    batchId: batch.map((item) => item.value),
    materialIds: materialId.map((item) => item.value),
    isMissingConsent,
    searchBy,
    searchByValue,
  };
};

export const DISABLE_SCAN_MSG = "Please search students to scan their ID.";
export const INVALID_RFID_MSG = "Invalid RFID. Please scan again.";
export const DUPLICATE_RFID_MSG = (rfid) =>
  failureToast(
    `Consent has already been recorded for RFID: ${rfid}. Please scan or enter a different RFID.`
  );
export const DETAILS_ABSENT_MSG =
  "Eligible student not present in the fetched list.";

export const inputHeight = "42px";

export const SCAN_BTN_STYLES = {
  position: "absolute",
  right: "21px",
  zIndex: "200",

  backgroundColor: "#00B0F5",
  color: "#FFFFFF",

  padding: "10px 16px",
  border: "none",
  borderRadius: "4px",
  lineHeight: "12px",
  height: "29px",
  fontSize: "12px",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Gilroy-Medium",
};

export const LIST_STYLES = {
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
};

export const SCANNED_COUNT_STYLES = {
  backgroundColor: "#f0f0f0",
  borderRadius: "12px",
  padding: "4px 10px",
};

export const LastUpdatedDetails = (lastUpdatedOn, lastUpdatedBy) => {
  if (lastUpdatedBy)
    return `${getFormattedDate(lastUpdatedOn)} at ${getUpdatedTime(
      lastUpdatedOn
    )} by ${lastUpdatedBy}`;

  return `${getUpdatedTime(lastUpdatedOn)} on ${getFormattedDate(
    lastUpdatedOn
  )}`;
};

export const ADMIN_ROLE_TYPES = ["BR_STOCK_RCC_OWNED", "CR_STOCK_RCC_OWNED"];
